'use client'

import { useEffect } from 'react'
import { toast } from 'sonner'

export function WelcomeToast() {
  useEffect(() => {
    if (!document.cookie.includes('welcome-to-347-facts-toast=347')) {
      toast('Welcome to 347 Facts!', {
        id: 'welcome-to-347-facts-toast',
        duration: Infinity,
        onDismiss: () => {
          // biome-ignore lint/suspicious/noDocumentCookie: simple dismiss preference; Cookie Store API not needed here
          document.cookie = 'welcome-to-347-facts-toast=347;max-age=31536000;path=/'
        },
        description: <>Stay Informed on State Route 347 Projects.</>,
        closeButton: true,
      })
    }
  }, [])

  return null
}
